module.exports = __webpack_public_path__ + "img/TOT_green.f18d3daf.png";